<template>
  <component :is="tag" :class="[classes]" :style="styles"
  >
    <slot/>
  </component>
</template>

<script>

export default {
  name: 'VCard',
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    outlined: Boolean,
    shaped: Boolean,
    height: {
      type: String,
      default: 'auto',
    },
  },
  computed: {
    classes () {
      return {
        'v-card': true,
        'v-sheet': true,
        'v-sheet--outlined': this.outlined,
        'v-sheet--shaped': this.shaped,
      }
    },
    styles() {
      return {
        height: `${this.height}px`,
      };
    },
  }
};
</script>

<style lang="scss">
@import "VCard";
</style>
